(function ($) {
	$(function () {
		$(".photos .slides").slick({
			arrows			:	false,
			dots			:	false,
			slidesToShow	:	1,
			asNavFor		:	".thumbnails",
		});

		$(".photos .thumbnails").slick({
			slidesToShow	:	4,
			slidesToScroll	:	4,
			asNavFor		:	".slides",
			focusOnSelect	:	true,
			centerMode		:	true,
			centerPadding	:	0,
		});

		$("input[name=city]").on("change", function () {
			let target	=	$(this).val();

			$(".areas .area .inner:visible").fadeOut();
			$(".areas .area .inner[data-name="+ target +"]").fadeIn(function () {
				$(".areas .area .inner").find("input").attr("disabled", true);
				$(".areas .area .inner:visible").find("input").attr("disabled", false);
			}).css({display:	"flex"});
		}).filter(":checked").trigger("change");

		$("input[name=type]").on("change", function () {
			if($(this).val() == "rent") {
				$(".rentOnly").show();
				$(".tradeOnly").hide();
			}
			else {
				$(".rentOnly").hide();
				$(".tradeOnly").show();
			}
		}).filter(":checked").trigger("change");

		$("input[name=kind]").on("change", function () {
			let $form	=	$(this).closest("form");
			let kind	=	$(this).val();

			$form.find("input, select").filter(":not(:disabled)").each(function () {
				let $target	=	$(this);

				if($target.attr("type") == "checkbox") {
					$form.find("input[type=checkbox][name=\""+ $target.attr("name") +"\"][value=\""+ $target.attr("value") +"\"]:disabled").prop("checked", $target.is(":checked"));
				}
				else if($target.attr("type") == "radio") {
					$form.find("input[type=radio][name=\""+ $target.attr("name") +"\"][value=\""+ $target.attr("value") +"\"]:disabled").prop("checked", $target.is(":checked"));
				}
				else {
					$form.find("[name=\""+ $target.attr("name") +"\"]:disabled").val($target.val());
				}
			});

			$form.find("[data-kind]").each(function () {
				let $target		=	$(this);
				let kinds	=	$target.attr("data-kind").split(",");

				if($.inArray(kind, kinds) != -1) {
					$target.show().find("input, select").attr("disabled", false);
				}
				else {
					$target.hide().find("input, select").attr("disabled", true);
				}
			});
		}).filter(":checked").trigger("change");

		$(".results").on("click", ".empty > span", function () {
			let $target	=	$(this);

			$target.animate({
				opacity	:	0,
				height	:	0,
			});
			$target.closest(".summary").next(".rooms").slideDown();
		});

		$(".sidebar").on("change first", "input, select", function (e) {
			let $form		=	$(this).closest("form");
			let position	=	$("html, body").scrollTop();

			$(".results .item").show();

			$.each(["kind", "use"], function (key, type) {
				let $input	=	$("input[name='"+ type +"']:checked:not(:disabled)");
				let value	=	$input.val() || "";

				if(value != "") {
					$(".results .item[data-"+ type +"!='"+ value +"']").hide();
				}
			});

			$.each(["price", "exlusive", 'space'], function (key, type) {
				let min	=	parseFloat($("select[name='"+ type +"Min']:not(:disabled)").val()) || "";
				let max	=	parseFloat($("select[name='"+ type +"Max']:not(:disabled)").val()) || "";

				if(min != "" && max != "" && min > max) {
					min	=	parseFloat($("select[name='"+ type +"Max']:not(:disabled)").val()) || "";
					max	=	parseFloat($("select[name='"+ type +"Min']:not(:disabled)").val()) || "";
				}

				$(".results .item[data-"+ type +"]").each(function () {
					let $target	=	$(this);
					let value	=	$target.attr("data-"+ type);
					
					if(min != "" && max != "") {
						if(value > max || value < min) {
							$target.hide();
						}
					}
					else if(max != "") {
						if(value > max) {
							$target.hide();
						}
					}
					else if(min != "") {
						if(value < min) {
							$target.hide();
						}
					}
				});
			});

			$.each(["old", "station"], function (key, type) {
				let $input	=	$(".sidebar input[name='"+ type +"']:checked:not(:disabled)");

				if($input.length != 0) {
					let value	=	$input.val();

					if(value == "newly") {
						$(".results .item[data-new!=1]").hide();
					}
					else if(value != "") {
						$(".results .item").each(function () {
							let $target	=	$(this);

							if(parseInt($target.attr("data-"+ type)) > value || parseInt($target.attr("data-"+ type)) < 0) {
								$target.hide();
							}
						});
					};
				}
			});

			$.each(["area[]", "layout[]", "city[]"], function (key, type) {
				let $inputs	=	$("input[name='"+ type +"']:checked:not(:disabled)");

				if($inputs.length != 0) {
					$(".results .item").each(function () {
						let $target	=	$(this);
						
						$inputs.each(function () {
							if($target.attr("data-"+ type.replace("[]", "")) == $(this).val()) {
								$target.attr("data-passed", "1");
							}
						});
					});

					$(".results .item[data-passed!=1]").hide();
					$(".results .item[data-passed]").removeAttr("data-passed");
				}
			});

			$.each(["position[]", "structure[]", "condition[]", "current[]", "parking[]", "gas[]", "bus[]", "aircon[]", "net[]", "security[]", "other[]", "classification[]", "facility[]", "ownership[]"], function (key, type) {
				let $inputs		=	$("input[name='"+ type +"']:checked:not(:disabled)");
				let $relation	=	$("input[name='"+ type.replace("[]", "") +"Relation']:not(:disabled)");

				if($inputs.length != 0) {
					$(".results .item").each(function () {
						let $target	=	$(this);
						
						$inputs.each(function () {
							if($.inArray($(this).val(), $target.attr("data-"+ type.replace("[]", "")).split(",")) != -1) {
								$target.attr("data-passed", "1");
							}
							else {
								$target.attr("data-failed", "1");
							}
						});
					});
					
					if($relation.is(":checked")) {
						$(".results .item[data-failed=1]").hide();
					}
					else {
						$(".results .item[data-passed!=1]").hide();
					}
					
					$(".results .item[data-passed]").removeAttr("data-passed");
					$(".results .item[data-failed]").removeAttr("data-failed");
				}
			});

			if(e.type == "first") {
				$(".results").fadeIn();
			}

			$(window).trigger("resize");

			if($(".results .item:visible").length != 0) {
				$(".results .item.spacer").show();
			}
			else {
				$(".results .item.nothing").show();
			}

			$(".sidebar .result .count").text($(".results .item:visible").length);

			$(".results").css({minHeight:	$(".sidebar").innerHeight()});
			$("html, body").scrollTop(position);
		});
		
		$(".sidebar input[name=kind]:checked").trigger("first");

		$(".sort li[data-orderby]").on("click", function () {
			let $target	=	$(this);
			let order	=	$target.attr("data-order");
			let orderby	=	$target.attr("data-orderby");

			let $items	=	$(".results .item").sort(function (a, b) {
				if(parseFloat($(a).attr("data-"+ orderby)) > parseFloat($(b).attr("data-"+ orderby))) {
					return (order == "asc")?	1	:	-1;
				}
				else if(parseFloat($(a).attr("data-"+ orderby)) < parseFloat($(b).attr("data-"+ orderby))) {
					return (order == "asc")?	-1	:	1;
				}
				else {
					return 0;
				}
			});

			$(".results .item").remove();
			$(".results .sort").after($items);

			$(".sort li[data-orderby]").removeClass("active");
			$(".sort li[data-order]").attr("data-order", "desc");

			$target.addClass("active");
			$target.attr("data-order", (order == "asc")? "desc" :	"asc");
		}).filter(":first").trigger("click");

		$("input[name=city]").on("change", function () {
			let $target	=	$(this);

			if($target.is(":checked")) {
				$target.closest("label").next().css({display:	"flex"}).css({display:	"none"});
				$target.closest("label").next().slideDown().css({display:	"flex"}).find("input").attr("disabled", false);
			}
			else {
				$target.closest("label").next().slideUp(function () {
					$(this).find("input").attr("disabled", true);
				}).css({display:	"flex"});
			}
		});

		$(".search.open").on("click", function () {
			$(".sidebar").css({left:	0});
			$("body").css({overflow:	"hidden"});
		});

		$(".search.close").on("click", function () {
			$(".sidebar").css({left:	""});
			$("body").css({overflow:	""});
		});

		let current		=	$(window).scrollTop();
		let position	=	parseInt($(".sidebar").css("top"));
		let offset		=	position;

		$(window).on("resize", function () {
			$(".results .item").each(function () {
				let $item	=	$(this);
				let width	=	$item.find(".spacer").width();

				$item.find(".more").css({width:	width}).show();
				$item.find(".contact").css({width:	width}).show();
			});
		}).trigger("resize");

		$(window).on("scroll", function () {
			let margin		=	$(window).innerHeight() - $(".sidebar").height();
			let difference	=	current - $(window).scrollTop();

			offset	=	offset + difference;

			if(difference < 0) {
				if(offset < margin) {
					offset	=	margin;
				}
				
				$(".sidebar").css({top:	offset});
			}
			else if(difference > 0) {
				if(offset > position) {
					offset	=	position;
				}

				$(".sidebar").css({top:	offset});
			}

			current	=	$(window).scrollTop();
		});

		$(".panoramas").slick({
			arrows			:	true,
			dots			:	false,
			draggable		:	false,
			swipe			:	false,
			slidesToShow	:	1,
		});

		$(".panoramas .panorama").each(function () {
			let $target	=	$(this);
			let src		=	$target.find("img").attr("src");

			$target.on("mousedown", function () {
				$(".panoramas").addClass("active");
			});

			$target.on("mouseup mouseleave", function () {
				$(".panoramas").removeClass("active");
			});

			$target.createThetaViewer(src);
			$target.find("img").remove();
		});
	});
})(jQuery);